/* @ngInject */

export default (ReviewProductSplit) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function ReviewProduct(id, idLender, lenderTurnaround, productSplits, isPreferred) {
    this.id = id;
    this.idLender = idLender;
    this.lenderTurnaround = lenderTurnaround;
    this.productSplits = productSplits;
    this.isPreferred = isPreferred;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  ReviewProduct.Blank = function () {
    return ReviewProduct.Build({
      id: _.uuid(),
      idLender: '',
      lenderTurnaround: '',
      productSplits: [],
      isPreferred: false
    });
  };
  ReviewProduct.Build = function (data) {
    return new ReviewProduct(
      data.id ? data.id : _.uuid(),
      data.idLender ? data.idLender : '',
      data.lenderTurnaround ? data.lenderTurnaround : '',
      _.map(_.compact(data.productSplits), (productSplit) =>
        ReviewProductSplit.Build(productSplit)
      ),
      data.isPreferred ? data.isPreferred : false
    );
  };

  return ReviewProduct;
};
